// Copyright (c) Facebook, Inc. and its affiliates.
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { withStyles } from '@material-ui/core';
import Cancel from '@material-ui/icons/Cancel';

import withMobileDialog from '@material-ui/core/withMobileDialog';

import BoundingBox from './BoundingBox';


const DialogContent = withStyles(theme => ({
  root: {
    padding: '0px 0.7rem 0.7rem 0.7rem !important',
    [theme.breakpoints.up('sm')]: {
        width: '60vh',
        padding: '0px 1.6rem 1.6rem 1.6rem !important',
    },
  },
}))(MuiDialogContent);


const SampleDialog = (props) => {
    if (!props.result) {
        return ''
    }
    let fullWidth = false;
    if (props.screenType === '100') {
        fullWidth = true;
    };

    return (
        <div>
            <Dialog
                open={props.open}
                fullWidth={fullWidth}
                maxWidth="lg"
                onClose={props.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <Typography variant="subtitle1" align="center">
                        {props.result.coco_url.length ?
                            <Link target="_blank" href={props.result.coco_url.replace("http://images.cocodataset.org", "https://s3.us-east-1.amazonaws.com/images.cocodataset.org")}>Original URL</Link> :
                            ''}

                </Typography>
                <DialogContent
                    id="alert-dialog-description"
                >
                    <BoundingBox
                        showSegms={props.showSegms}
                        showAll={props.showAll}
                        isDialog={true}
                        imageUrl={props.result.coco_url}
                        selectedSynsets={props.selectedSynsets}
                        boxes={props.boxes}
                    />
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default withMobileDialog()(SampleDialog);
